import React from "react";
import { GridItem } from "@chakra-ui/react";
import { DayViewDayColumnProps } from "./DayViewDayColumn.types";
import { useVeriDatePicker } from "../../../../VeriDatePickerContext";
import { DatePickerWeekDay } from "../../../../types";
import DatePickerButton from "../../../../components/DatePickerButton/DatePickerButton";
import {
  isDaySelected,
  selectedDateConsideringNegativeTimezoneOffset,
} from "../../../../utils";

const DayViewDayColumn: React.FC<DayViewDayColumnProps> = ({
  days,
  currentDate,
  ...rest
}) => {
  const datePicker = useVeriDatePicker();

  const dateToday = new Date();

  const selectDate = (newDate: DatePickerWeekDay) => {
    datePicker.setDate(newDate.date);
    datePicker.onDayPick?.(newDate.date);
  };

  const dateSelected = selectedDateConsideringNegativeTimezoneOffset(
    datePicker.selectedDateString,
  );

  const handleDayClick = (day: DatePickerWeekDay) => {
    selectDate(day);
  };

  return (
    <>
      {days.map((day, dayIndex) => {
        const isDayDisabled = !datePicker.isDateEnabled(day.date);

        return (
          <GridItem key={dayIndex} {...rest}>
            <DatePickerButton
              isDisabled={isDayDisabled}
              isSelected={
                datePicker.isRangePicker
                  ? datePicker.isDateInRange(day.date)
                  : !!(
                      datePicker.selectedDate &&
                      isDaySelected(dateSelected, day.date)
                    )
              }
              isGrey={currentDate.getMonth() !== day.date.getMonth()}
              isPartialSelected={isDaySelected(dateToday, day.date)}
              onClick={
                !isDayDisabled ? handleDayClick.bind(null, day) : undefined
              }
              title={
                day.monthName + " " + day.day + ", " + day.date.getFullYear()
              }
              isInRange={datePicker.isRangePicker}
              isStartRange={datePicker.isFirstDateInRange(day.date)}
              isEndRange={datePicker.isLastDateInRange(day.date)}
            >
              {day.day}
            </DatePickerButton>
          </GridItem>
        );
      })}
    </>
  );
};

export default DayViewDayColumn;
